import React from "react";
import s from "./style.module.css";
import cn from "classnames";
import { useLocation } from "react-router-dom";
import history from "../../helpers/history";

const InternalNavigation = ({ items = [] }) => {
  const { hash } = useLocation();

  const onClick = (id) => {
    history.push(`#${id}`);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  return (
    <div className={s.bg}>
      <div className={s.overflow}>
        <div className={s.wrap}>
          {items.map(({ id, text }) => (
            <a
              key={id}
              className={cn(s.link, {
                [s.active]: hash.replace("#", "") === id,
              })}
              href={`#${id}`}
              onClick={(e) => {
                e.preventDefault();
                onClick(id);
              }}
            >
              {text}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InternalNavigation;
